import { createSlice } from '@reduxjs/toolkit';
import * as userService from '../services/userService';
import config from '../config';

const initialState = {
    loading : false,
    hasErrors : false,
    users : [],
    user : {},
    list_page : [],
    pesan : ''
}

const userStoreSlice = createSlice({
    name : 'userStore',
    initialState,
    reducers : {
        getData : (state) => { state.loading = true},
        getDataSuccess : (state, action) => {
            state.loading = false;
            state.hasErrors = false;
            state.users = action.payload.data;
            state.list_page = action.payload.list_page;
        },
        getDataFailure : (state) => { state.loading = false; state.hasErrors = true},
        setDetail : (state, action) => {
            state.loading = false;
            state.hasErrros = false;
            state.user = action.payload;
        },
        deleteData : (state, action) => {            
            state.loading = false;
            state.hasErrors = false;
            state.users = state.users.filter(item => item.id !== action.payload);
        },
        setPesan : (state, action) => {
            state.pesan = action.payload;
        }
    }
})

export const { getData, getDataSuccess, getDataFailure, setDetail, deleteData, setPesan } = userStoreSlice.actions;

export const userSelector = (state) => state.users;

export default userStoreSlice.reducer;


export function fetchUser(q='', limit=config.itemPerPage, page=1){
    return async(dispatch) => {
        dispatch(getData());
        try{
            const response = await userService.getUser(q, limit, page);
            const data = await response;            
            if(data.sukses === 'yes'){                
                dispatch(getDataSuccess(data))
            }else{
                dispatch(getDataFailure());
            }
        }catch(error){
            dispatch(getDataFailure());
        }
    }
}

export function fetchDetail(id){
    return async(dispatch) => {
        dispatch(getData());
        try{
            const response = await userService.getUser(`id=${id}`, 1, 1);
            const data = await response;            
            if(data.sukses === 'yes'){
                dispatch(setDetail(data.data))
            }else{
                dispatch(getDataFailure());
            }
        }catch(error){
            dispatch(getDataFailure());
        }
    }
}

// export function deleteRoom(id){
//     return async(dispatch) => {
//         dispatch(getData());
//         try{
//             const response = await userService.deleteRoom(id);
//             const data = await response;
//             if (data.sukses === 'yes'){
//                 dispatch(deleteData(id));
//                 dispatch(setPesan(data.pesan))
//             }else{
//                 dispatch(getDataFailure());
//             }
//         }catch(error){
//             dispatch(getDataFailure());
//         }
//     }
// }